import { DEFAULT_PAGE_SIZE } from '../../../../common/constants/table-config';
import { ListQueryParam } from '../../../../common/constants/list-query-param.constant';
import { AddressListFiltersModelBase } from '../constants';
import { AddressDetailsModel } from './address.model';

export class AddressListItemBrief extends AddressDetailsModel {
  hasWarning: boolean;
  warningMessage: string;

  constructor(params?: AddressListItemBrief) {
    super(params);

    if (params) {
      this.hasWarning = !params.name || (!params.country && !params.cityName && !params.street && !params.postCode);

      this.warningMessage =
        this.hasWarning && !params.name
          ? 'administration.addressManagement.warningAddressName'
          : 'administration.addressManagement.warningAddressData';
    }
  }
}

export class AddressListSearchCriteria extends AddressListFiltersModelBase {
  [ListQueryParam.Size] = DEFAULT_PAGE_SIZE;
  [ListQueryParam.Page] = 0;

  constructor(params?: AddressListSearchCriteria) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}
